import { Flex, FlexProps, Text } from "@chakra-ui/react"
import { ReactNode } from "react"
import { CInfo } from "./Icons"

type Props = { children: ReactNode } & FlexProps

const InfoIconWithTextElement = ({ children, ...rest }: Props) => {
  return (
    <Flex alignItems="flex-start" gap="2" fontSize={{ base: "sm", md: "md" }} {...rest}>
      <CInfo mt="0.5" />
      <Text fontWeight="normal" as="span">
        {children}
      </Text>
    </Flex>
  )
}

export default InfoIconWithTextElement
